import React from 'react';
import { OptionValue } from '../../../services/types/Misc';
import FormCheckboxGroupItem from './FormCheckboxGroupItem';

interface Props {
  name: string;
  elements: OptionValue[];
  onChangeAction?: () => void;
}

const FormCheckboxGroup: React.FC<Props> = ({ name, elements, onChangeAction }) => {
  const drawCheckbox = (option: OptionValue) => (
    <FormCheckboxGroupItem
      id={option.id.toString()}
      key={option.id}
      name={name}
      text={option.text}
      value={option.value || ''}
      disabled={option.disabled || false}
      onChangeAction={onChangeAction}
    />
  );

  return <>{elements.map((option) => drawCheckbox(option))}</>;
};

export default FormCheckboxGroup;
